import React from "react";
import { View } from "react-native";
import { ClientInput } from "@/components/inputs/ClientInput";
import { ProjectInput } from "@/components/inputs/ProjectInput";
import { EstimateForm } from "./types";

interface EstimateFieldsProps {
  estimate: EstimateForm;
  updateEstimate: (patch: Partial<EstimateForm>) => void;
}

export function EstimateFields({ estimate, updateEstimate }: EstimateFieldsProps) {
  return (
    <View style={{ gap: 16 }}>
      <ClientInput
        value={estimate.client_id || null}
        state="editing"
        label="Client *"
        onChange={(clientId) => updateEstimate({ client_id: clientId || "", project_id: "" })}
      />

      <ProjectInput
        value={estimate.project_id || null}
        clientId={estimate.client_id || null}
        state="editing"
        label="Project *"
        onChange={(projectId) => updateEstimate({ project_id: projectId || "" })}
      />
    </View>
  );
}
